import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import './PhysRecommendedReading.css';

const PhysRecommendedReading = () => {
  return (
    <div className='app__about-read'>
      <h5>Niacinamida</h5>
      <h2>Niacinamida: ciencia, calma y memoria celular</h2>
      <button type='button' className='app__about-read-btn'>
        Ver Árticulo <span><BsArrowRight/></span>
      </button>
    </div>
  );
};

export default PhysRecommendedReading;